export default __webpack_public_path__ + "static/ring-fca8a868e3b834f73ad771fd3364f069.png";